import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';
import { type SkillAnalyticsScope, type SkillAnalyticsType } from './skillAnalytics';
import META from './useTrackSkillPublishedToWorkspace.meta';

export type UseTrackSkillPublishedToWorkspaceParams = {
  scope: SkillAnalyticsScope;
  skill_id: string;
  type: SkillAnalyticsType;
};

export const useTrackSkillPublishedToWorkspace = () => {
  const { track } = useAnalyticsUtilities();

  const trackSkillPublishedToWorkspace = useCallback(
    (params: UseTrackSkillPublishedToWorkspaceParams) => {
      track(META.name, params);
    },
    [track],
  );

  return { trackSkillPublishedToWorkspace };
};
